import React from 'react'
import SharedNotesModal from './SharedNotesModal'

const ModalCustomerNotes = ({closeModal, customerInfo}) => {
    const customerName = customerInfo?.customer_name ?? customerInfo?.name ?? '';

    return (
        <SharedNotesModal
            closeModal={closeModal}
            entityInfo={customerInfo}
            title={`${customerName}: Customer Notes`}
            fetchPath='/customer_notes/customer/'
            createPath='/customer_notes/'
            createEntityKey='customer'
        />
    )
}

export default ModalCustomerNotes